export function parseForm<T extends string = string>(
  elements: HTMLFormControlsCollection,
  names: T[]
): Record<T, string> {
  return names.reduce((res, name) => {
    const element = elements.namedItem(name) as HTMLInputElement
    return {
      ...res,
      [name]: element.value,
    }
  }, {}) as Record<T, string>
}
